import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import styles from './ui-inputgroup.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIInputGroup
 * @element ui-inputgroup
 * @classdesc Represents a class for <code>ui-inputgroup</code> element.
 * Combines together inputs and labels like currencies or selects.
 * @slot
 * @example
 * <ui-field label="Select + currency">
 *   <ui-inputgroup>
 *     <select name="units" id="test-render-id-3">
 *       <option value="EUR">My account</option>
 *       <option value="USD">Billy's account</option>
 *     </select>
 *     <label class="units">EUR</label>
 *   </ui-inputgroup>
 * </ui-field>
 */
@Component({ tag: 'ui-inputgroup', styles })
export class UIInputGroup extends UIElement {
    /**
     * @inheritDoc
     */
    override render(): void {
        this.setAttribute('role', 'group');
    }
}
